import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { signInWithEmailAndPassword } from "firebase/auth";
import { RiWhatsappFill } from "react-icons/ri";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import toast from 'react-hot-toast';
import 'react-tabs/style/react-tabs.css';
import { auth } from "../../firebase";
import Logo from '../../images/bcs-logo.png'

const getFirebaseErrorMessage = (error) => {
    const errorCode = error?.code?.replace("Firebase: Error (", "").replace(")", "");

    switch (errorCode) {
        case "auth/email-already-in-use":
            return "This email is already in use. Try logging in instead.";
        case "auth/invalid-email":
            return "Invalid email format. Please check and try again.";
        case "auth/user-not-found":
            return "No account found with this email.";
        case "auth/wrong-password":
            return "Incorrect password. Please try again.";
        case "auth/weak-password":
            return "Password is too weak. Use at least 6 characters.";
        case "auth/network-request-failed":
            return "Network error. Check your internet connection.";
        case "auth/invalid-credential":
            return "Invalid email or password. Register your BIO DATA in the BCS Official Website.";
        default:
            return error?.message || "An unknown error occurred.";
    }
};

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showMemberPassword, setShowMemberPassword] = useState(false);
    const [showGuestPassword, setShowGuestPassword] = useState(false);
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        try {
            const user = await signInWithEmailAndPassword(auth, email, password);
            navigate(`/dashboard/${user?.user?.uid}`);
        } catch (err) {
            toast.error(getFirebaseErrorMessage(err));
        }
    };

    return (
        <div 
            className="min-h-screen bg-gray-50 flex flex-col justify-center items-center py-12 px-4 sm:px-6 lg:px-8" 
            style={{
                backgroundImage: `url("https://i0.wp.com/www.angelsagainstabuse.org/wp-content/uploads/2018/11/blue-moving-flowing-abstract-waves-on-white-background-blurred-smooth-graphic-motion-design-video-animation-1920x1080_vhhueydte__F0000.png?fit=1920%2C1080&ssl=1")`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat'
            }}
        >
            <img
                src={Logo}
                alt="BCS-LOGO"
                className="mb-8"
            />
            <p className="text-gray-600 text-center mb-8 font-bold">
                Welcome to the BCS Holy Vestry Portal.
            </p>

            <div className="w-full max-w-xl">
                <Tabs>
                    <TabList className="flex justify-center gap-6 mb-8 bg-[#eee] p-2 rounded-full shadow-sm border border-[#eee]">
                        <Tab 
                            className="px-8 py-3 text-base font-semibold rounded-full transition-all cursor-pointer"
                            selectedClassName="bg-white text-blue-600 shadow-md"
                        >
                            Member
                        </Tab>
                        <Tab 
                            className="px-8 py-3 text-base font-semibold rounded-full transition-all cursor-pointer"
                            selectedClassName="bg-white text-blue-600 shadow-md"
                        >
                            Guest
                        </Tab>
                    </TabList>

                    <TabPanel>
                        <div className="bg-white shadow-sm border border-gray-200 p-4 rounded-lg">
                            <form className="space-y-6">
                                <div>
                                    <label htmlFor="email" className="block text-sm font-medium">
                                        Email
                                    </label>
                                    <input
                                        id="email"
                                        type="email"
                                        placeholder="Enter your email"
                                        onChange={(e) => setEmail(e.target.value)}
                                        className="mt-1 w-full flex h-9 rounded-md border border-neutral-200 bg-transparent px-3 py-1 text-base shadow-sm transition-colors"
                                    />
                                </div>
                                <div>
                                    <label htmlFor="password" className="block text-sm font-medium">
                                        Password
                                    </label>
                                    <div className="mt-1 relative">
                                        <input
                                            id="password"
                                            type={showMemberPassword ? "text" : "password"}
                                            onChange={(e) => setPassword(e.target.value)}
                                            placeholder="Enter your password"
                                            className="w-full flex h-9 rounded-md border border-neutral-200 bg-transparent px-3 py-1 pr-10 text-base shadow-sm transition-colors"
                                        />
                                        <button
                                            type="button"
                                            onClick={() => setShowMemberPassword((prev) => !prev)}
                                            className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-500 hover:text-gray-700"
                                            aria-label={showMemberPassword ? "Hide password" : "Show password"}
                                        >
                                            {showMemberPassword ? <FaEyeSlash /> : <FaEye />}
                                        </button>
                                    </div>
                                </div>
                                <button
                                    onClick={handleLogin}
                                    type="submit"
                                    className="w-full bg-black py-3 text-sm font-medium bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
                                >
                                    Login
                                </button>
                            </form>
                        </div>
                    </TabPanel>

                    <TabPanel>
                        <div className="bg-white shadow-sm border border-gray-200 p-4 rounded-lg">
                            <form className="space-y-6">
                                <a
                                    href="https://wa.me/+2348030489084"
                                    className="w-full py-3 bg-green-500 text-white text-sm font-medium rounded-md hover:bg-green-600 transition-colors flex items-center justify-center"
                                >
                                    Access Not Yet Assigned? Contact &nbsp; <RiWhatsappFill size={25}/>
                                </a>
                                <div>
                                    <label htmlFor="guest-email" className="block text-sm font-medium">
                                        Email
                                    </label>
                                    <input
                                        id="guest-email"
                                        type="email"
                                        placeholder="Enter your email"
                                        onChange={(e) => setEmail(e.target.value)}
                                        className="mt-1 w-full flex h-9 rounded-md border border-neutral-200 bg-transparent px-3 py-1 text-base shadow-sm transition-colors"
                                    />
                                </div>
                                <div>
                                    <label htmlFor="guest-password" className="block text-sm font-medium">
                                        Password
                                    </label>
                                    <div className="mt-1 relative">
                                        <input
                                            id="guest-password"
                                            type={showGuestPassword ? "text" : "password"}
                                            onChange={(e) => setPassword(e.target.value)}
                                            placeholder="Enter your password"
                                            className="w-full flex h-9 rounded-md border border-neutral-200 bg-transparent px-3 py-1 pr-10 text-base shadow-sm transition-colors"
                                        />
                                        <button
                                            type="button"
                                            onClick={() => setShowGuestPassword((prev) => !prev)}
                                            className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-500 hover:text-gray-700"
                                            aria-label={showGuestPassword ? "Hide password" : "Show password"}
                                        >
                                            {showGuestPassword ? <FaEyeSlash /> : <FaEye />}
                                        </button>
                                    </div>
                                </div>
                                <button
                                    onClick={handleLogin}
                                    type="submit"
                                    className="w-full bg-black py-3 text-sm font-medium bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
                                >
                                    Login
                                </button>
                            </form>
                        </div>
                    </TabPanel>
                </Tabs>
            </div>
        </div>
    );
};

export default Login;